import { PricingPlansType } from "@/components/PricingPlans";
import * as Schema from "../types/schema";

import { excludeDraftsFilter } from "./filters";
import { TestimonialCarouselProps } from "@/components/SlidingTestimonialsCarousel";
import { HeaderNavigationProps } from "@/components/HeaderNavigation";
import { MultiColumnSelectionType } from "@/components/MultiColumnSection";
import { HeroWithFormType } from "@/components/HeroWithForm";
import { Colorways } from "src/theme";
import { SEOPageData } from "@/types/seoPageData";
import { FooterNavigationProps } from "@/components/FooterNavigation/query";

export type PricingLandingProfessionalsData = Pick<
  Schema.PricingLandingProfessionals,
  "_id"
> & {
  colorway: Colorways;
  hero: Schema.PricingLandingHero;
  pricing: PricingPlansType;
  services: [MultiColumnSelectionType];
  testimonials: TestimonialCarouselProps;
  navSections: HeaderNavigationProps["navSections"];
  form: HeroWithFormType;

  moduleQuestions: {
    moduleFeatureFlag: Schema.FeatureFlag;
    moduleInput: Pick<
      Schema.Questions,
      | "heading"
      | "subHeading"
      | "cta1Text"
      | "cta1URL"
      | "cta2Text"
      | "cta2URL"
      | "image"
    > & {
      testimonials: Schema.Testimonial[];
    };
  };
  footerPayload: FooterNavigationProps;
} & SEOPageData;

export const getPricingLandingProfessionalsQuery = (preview?: boolean) => `
  *[_type == "pricingLandingProfessionals"${
    !preview ? ` && ${excludeDraftsFilter}` : ""
  }]{
    _id,
    seo,
    colorway,
    hero,
    pricing->{
      sectionIntro,
      pricingPlans[] {...}
    },
    services[]-> {...},
    testimonials-> {...},
    form-> {...},
    moduleQuestions{
      moduleFeatureFlag,
      moduleInput{
        heading,
        subHeading,
        cta1Text,
        cta1URL,
        cta2Text,
        cta2URL,
        image,
        testimonials[]->
      }
    },
  }
`;
